import { DM_Press } from "../../Utils/Constants/ConstDmADC";
import  './PressureSensor.css';

export default function PressureSensor({adc, pmax, islink}) {

    const calculatePressure = () => {

        if (!adc || !pmax) return 0;
        
        const deltaADC = DM_Press.maxADC - DM_Press.minADC;
        if (deltaADC === 0) return 0;
        
        const result = DM_Press.Pmin +
                       (pmax - DM_Press.Pmin) * 
                       (adc - DM_Press.minADC) / 
                       deltaADC;
        
        return Math.max(0, result);
      };
      
      const pressure = calculatePressure();

    return(
       
        <div className='mapSensor'>
            {pressure > 0.1 && islink==='Online' && (
                <div>P: {pressure.toFixed(2)} Бар</div>
            )}                  
        </div>
    )
}